import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineChat, HiOutlineUser, HiOutlinePaperAirplane, HiOutlineMicrophone, HiOutlineStop, HiOutlineTrash, HiOutlineArrowLeft } from 'react-icons/hi';
import axiosInstance from '../../../config/axios';
import toastService from '../../../services/toast';
import AlertConfirmModal from '../../common/AlertConfirmModal';
import { useParams } from 'react-router-dom';

// خيارات الصور الرمزية المتاحة
const avatarOptions = [
  { id: 'avatar1', src: '/images/avatars/avatar1.png', alt: 'صورة رمزية 1' },
  { id: 'avatar2', src: '/images/avatars/avatar2.png', alt: 'صورة رمزية 2' },
  { id: 'avatar3', src: '/images/avatars/avatar3.png', alt: 'صورة رمزية 3' },
  { id: 'avatar4', src: '/images/avatars/avatar4.png', alt: 'صورة رمزية 4' },
  { id: 'avatar5', src: '/images/avatars/avatar5.png', alt: 'صورة رمزية 5' },
  { id: 'avatar6', src: '/images/avatars/avatar6.png', alt: 'صورة رمزية 6' },
  { id: 'avatar7', src: '/images/avatars/avatar7.png', alt: 'صورة رمزية 7' },
  { id: 'avatar8', src: '/images/avatars/avatar8.png', alt: 'صورة رمزية 8' },
];

// دالة للحصول على مسار الصورة الرمزية بناءً على المعرف
const getAvatarSrc = (avatarId) => {
  const avatar = avatarOptions.find(a => a.id === avatarId);
  return avatar ? avatar.src : '/images/default-avatar.png';
};

const dummyTrainees = [
  { 
    id: 1, 
    name: 'أحمد محمد', 
    unread: 2, 
    lastMessage: 'عندي سؤال في الدرس الثالث', 
    time: '10:30 ص',
    status: 'online'
  },
  { 
    id: 2, 
    name: 'سارة أحمد', 
    unread: 0, 
    lastMessage: 'شكراً جزيلاً على التوضيح', 
    time: '09:15 ص',
    status: 'offline'
  },
  { 
    id: 3, 
    name: 'محمد علي', 
    unread: 1, 
    lastMessage: 'متى موعد الامتحان القادم؟', 
    time: 'أمس',
    status: 'online'
  },
  { 
    id: 4, 
    name: 'فاطمة حسن', 
    unread: 0, 
    lastMessage: 'تم فهم الشرح', 
    time: 'أمس',
    status: 'offline'
  },
  { 
    id: 5, 
    name: 'عمر خالد', 
    unread: 3, 
    lastMessage: 'محتاج مساعدة في التمرين الأخير', 
    time: '12:45 م',
    status: 'online'
  },
  { 
    id: 6, 
    name: 'نور محمود', 
    unread: 0, 
    lastMessage: 'الفيديو مش شغال عندي', 
    time: '11:20 ص',
    status: 'away'
  },
  { 
    id: 7, 
    name: 'ياسر أحمد', 
    unread: 1, 
    lastMessage: 'هل يمكن تأجيل موعد التسليم؟', 
    time: 'الأمس',
    status: 'online'
  },
  { 
    id: 8, 
    name: 'ليلى سعيد', 
    unread: 0, 
    lastMessage: 'تم رفع المشروع النهائي', 
    time: 'منذ يومين',
    status: 'offline'
  }
];

const dummyMessages = [
  { id: 1, sender: { type: 'trainee', name: 'أحمد محمد' }, content: 'عندي سؤال في الدرس الثالث', time: '10:30 ص' },
  { id: 2, sender: { type: 'instructor', name: 'م. خالد محمود' }, content: 'تفضل، كيف أقدر أساعدك؟', time: '10:31 ص' },
  { id: 3, sender: { type: 'trainee', name: 'أحمد محمد' }, content: 'في الجزء الخاص بالـ async/await، هل يمكن استخدامه مع forEach؟', time: '10:32 ص' },
  { id: 4, sender: { type: 'admin', name: 'مدير النظام' }, content: 'لا ينصح باستخدام async/await مع forEach لأنه لا ينتظر الوعود. بدلاً من ذلك استخدم for...of أو Promise.all مع map.', time: '10:35 ص' },
];

const ChatCard = () => {
  const { id } = useParams();
  const courseId = id;
  
  // طباعة معرف الدورة للتشخيص
  // معرف الدورة المستخرج من الرابط

  // حالة البيانات
  const [trainees, setTrainees] = useState([]);
  const [selectedTrainee, setSelectedTrainee] = useState(null);
  const [newMessage, setNewMessage] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const [messages, setMessages] = useState([]);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [courseName, setCourseName] = useState('');
  const [lastMessageId, setLastMessageId] = useState(0);
  const [conversationId, setConversationId] = useState(null);
  const [traineeStatus, setTraineeStatus] = useState('offline');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [traineeToDelete, setTraineeToDelete] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [activeView, setActiveView] = useState('list'); // 'list' أو 'chat'

  // المراجع
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const messagesEndRef = useRef(null);

  // جلب معلومات الدورة والمتدربين
  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        // جلب معلومات الدورة
        const courseResponse = await axiosInstance.get(`/api/courses/${courseId}`);
        setCourseName(courseResponse.data.name);
        
        // جلب المتدربين الذين لديهم أسئلة في الدورة
        const traineesResponse = await axiosInstance.get(`/api/admin/instructor/chat/trainees/${courseId}`);
        
        // معالجة بيانات المتدربين
        
        if (traineesResponse.data && Array.isArray(traineesResponse.data)) {
          setTrainees(traineesResponse.data);
          
          // لا نختار أي متدرب تلقائياً - المدرب هو اللي هيختار
          // تم إزالة الاختيار التلقائي للمتدرب الأول
        } else {
          // تنسيق بيانات المتدربين غير صالح
          setTrainees([]);
        }
      } catch (error) {
        // خطأ في جلب بيانات الدورة
        toastService.error('حدث خطأ في تحميل بيانات الدورة والمتدربين');
      }
    };
    
    if (courseId) {
      fetchCourseDetails();
    }
  }, [courseId]);
  


  // جلب المحادثة عند اختيار متدرب - بدون بولينج
  useEffect(() => {
    const fetchConversation = async () => {
      if (!selectedTrainee || !courseId) {
        // لا يوجد متدرب محدد أو معرف دورة
        return;
      }
      
      setIsLoadingMessages(true);
      
      try {
        // جلب أو إنشاء محادثة مع المتدرب
        // بيانات مربع المحادثة
        
        // استخدام معرف المحادثة من المتدرب مباشرة إذا كان موجوداً
        let conversationId = null;
        
        if (selectedTrainee.conversation_id) {
          // استخدام معرف المحادثة من المتدرب مباشرة
          conversationId = selectedTrainee.conversation_id;
          // استخدام معرف المحادثة من المتدرب مباشرة
        } else {
          // إذا لم يكن موجوداً، نحاول الحصول عليه من API
          const response = await axiosInstance.post('/api/chat/conversations', {
            trainee_id: selectedTrainee.id,
            course_id: courseId
          });
          
          // استجابة API المحادثة
          
          // تحديد معرف المحادثة من الاستجابة
          if (response.data && response.data.conversation_id) {
            conversationId = response.data.conversation_id;
          } else if (response.data && response.data.data && response.data.data.conversation_id) {
            conversationId = response.data.data.conversation_id;
          }
        }
        
        setConversationId(conversationId);
        
        // بعد الحصول على معرف المحادثة، نجلب الرسائل
        if (conversationId) {
          try {
            // جلب الرسائل السابقة من المحادثة - مرة واحدة فقط
            // جلب الرسائل لمربع المحادثة
            
            // جلب الرسائل وتحديث حالة القراءة في نفس الوقت
            const messagesResponse = await axiosInstance.get(`/api/chat/conversations/${conversationId}/messages?mark_as_read=1`);
            
            // معالجة البيانات المستلمة من الخادم
            
            // تهيئة الرسائل وتحديث آخر معرف رسالة
            let messagesList = [];
            
            if (Array.isArray(messagesResponse.data)) {
              messagesList = messagesResponse.data;
              // استخدام البيانات كمصفوفة مباشرة
            } else if (messagesResponse.data && Array.isArray(messagesResponse.data.messages)) {
              messagesList = messagesResponse.data.messages;
              // استخدام مصفوفة data.messages
            } else if (messagesResponse.data && messagesResponse.data.data && Array.isArray(messagesResponse.data.data.messages)) {
              messagesList = messagesResponse.data.data.messages;
              // استخدام مصفوفة data.data.messages
            }
            
            if (messagesList.length > 0) {
              setMessages(messagesList);
              const lastMsg = messagesList[messagesList.length - 1];
              setLastMessageId(lastMsg.id);
              
              if (messagesResponse.data && messagesResponse.data.trainee_status) {
                setTraineeStatus(messagesResponse.data.trainee_status);
              }
              
              // تحديث قائمة المتدربين لإزالة عداد الرسائل غير المقروءة
              setTrainees(prevTrainees => {
                return prevTrainees.map(t => {
                  if (t.id === selectedTrainee.id) {
                    return { ...t, unread_count: 0 };
                  }
                  return t;
                });
              });
            }
          } catch (error) {
            // خطأ في جلب الرسائل
            setMessages([]);
          }
        }
      } catch (error) {
        // خطأ في جلب المحادثة
        toastService.error('حدث خطأ في تحميل المحادثة');
      } finally {
        setIsLoadingMessages(false);
      }
    };
    
    if (selectedTrainee) {
      fetchConversation();
    }
  }, [selectedTrainee, courseId]);
  

  


  // دالة التمرير التلقائي لآخر رسالة
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };

  // تنفيذ التمرير التلقائي عندما تتغير الرسائل
  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  

  


  // إرسال رسالة جديدة
  const handleSendMessage = async () => {
    if (!newMessage.trim() || !conversationId) return;
    
    try {
      // إنشاء نسخة من الرسالة المرسلة محلياً
      const localMessage = {
        id: Date.now(), // معرف مؤقت
        sender_type: 'admin',
        is_read: false,
        message: newMessage,
        created_at: new Date().toISOString(),
      };
      
      // إضافة الرسالة للعرض فوراً قبل الانتظار للرد من الخادم
      setMessages(prev => [...prev, localMessage]);
      setNewMessage(''); // مسح حقل الإدخال
      
      // تنفيذ التمرير التلقائي
      setTimeout(scrollToBottom, 100);
      
      // إرسال الرسالة للخادم باستخدام مسار المدرب الصحيح
      const response = await axiosInstance.post(`/api/chat/send-message`, {
        conversation_id: conversationId,
        course_id: courseId,
        message: newMessage,
        content_type: 'text',
        sender_type: 'instructor' // إضافة نوع المرسل بشكل صريح
      });
      
      // استجابة إرسال الرسالة
      
      // استبدال الرسالة المؤقتة بالرسالة من الخادم لتجنب التكرار
      if (response.data && response.data.id) {
        // إزالة الرسالة المؤقتة وإضافة الرسالة من الخادم
        setMessages(prev => {
          // إزالة الرسالة المؤقتة (الرسالة الأخيرة)
          const withoutTemp = prev.slice(0, -1);
          // إضافة الرسالة الحقيقية من الخادم
          return [...withoutTemp, response.data];
        });
        
        // تحديث آخر معرف رسالة
        setLastMessageId(response.data.id);
      }
      

      
    } catch (error) {
      // خطأ في إرسال الرسالة
      toastService.error('حدث خطأ في إرسال الرسالة');
    }
  };

  // دالة تسجيل الصوت
  const startRecording = async () => {
    if (!conversationId || !selectedTrainee) {
      toastService.error('يجب تحديد متدرب ومحادثة أولاً');
      return;
    }
    
    try {
      // طلب إذن الميكروفون
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: 'audio/webm',
        audioBitsPerSecond: 128000 // تقليل جودة الصوت لتحسين الأداء
      });
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      // تخزين البيانات المسجلة
      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      // عند انتهاء التسجيل
      mediaRecorder.onstop = () => {
        // إنشاء ملف صوتي من البيانات المسجلة
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/mp3' });
        
        // إرسال الرسالة الصوتية
        sendAudioMessage(audioBlob);
        
        // إغلاق المسارات الصوتية
        stream.getTracks().forEach(track => track.stop());
      };
      
      // بدء التسجيل
      mediaRecorder.start();
      setIsRecording(true);
      toastService.info('جاري التسجيل...');
    } catch (error) {
      // خطأ في الوصول إلى الميكروفون
      toastService.error('لا يمكن الوصول إلى الميكروفون. يرجى التحقق من إعدادات المتصفح.');
    }
  };

  // إيقاف التسجيل
  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      // إغلاق التوست فوراً عند إيقاف التسجيل
      toastService.dismiss();
    }
  };
  
  // دالة إرسال الرسالة الصوتية
  const sendAudioMessage = async (blob) => {
    if (!conversationId || !selectedTrainee) return;
    
    try {
      // إرسال رسالة صوتية
      // إنشاء FormData لإرسال الملف
      const formData = new FormData();
      formData.append('conversation_id', conversationId);
      formData.append('course_id', courseId);
      formData.append('content_type', 'audio');
      formData.append('message', ' '); // إضافة حقل message فارغ
      formData.append('sender_type', 'instructor'); // إضافة نوع المرسل (مدرب)
      formData.append('file', blob, `voice_message_${Date.now()}.mp3`); // استخدام file بدلاً من audio_file
      
      // التحقق من محتوى FormData
      
      // إرسال الطلب
      const response = await axiosInstance.post('/api/chat/send-message', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      // إضافة الرسالة إلى قائمة الرسائل
      if (response.data) {
        setMessages(prev => [...prev, response.data]);
        scrollToBottom();
      }
    } catch (error) {
      // خطأ في إرسال الرسالة الصوتية
      toastService.error('حدث خطأ أثناء إرسال الرسالة الصوتية');
    }
  };

  // تحقق من حجم الشاشة
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // تحقق مرة أولى عند التحميل
    checkMobile();
    
    // استمع لتغيير حجم النافذة
    window.addEventListener('resize', checkMobile);
    
    // تنظيف عند إلغاء المكون
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []); // مصفوفة التبعيات فارغة لتشغيل مرة واحدة فقط

  // عند اختيار متدرب
  const handleTraineeSelect = (trainee) => {
    setSelectedTrainee(trainee);
    if (isMobile) setActiveView('chat');
  };

  return (
    <div className={`${isMobile ? 'p-0' : 'p-6'} h-[calc(100vh-6rem)]`}>
      <div className="bg-white dark:bg-gray-800 shadow-sm rounded-t-lg rounded-b-lg h-full flex flex-col">
        {/* رأس البطاقة */}
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-col items-center justify-center md:flex-row md:justify-between">
          <HiOutlineChat className="h-6 w-6 text-blue-600 hover:text-blue-700 dark:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 md:mb-0 md:order-2" />
          <div className="flex flex-col items-center md:flex-row md:items-center gap-1 md:gap-2 md:order-1">
            <h1 className="text-lg font-medium text-gray-900 dark:text-white">اسأل مدرب</h1>
            <span className="hidden md:inline text-sm text-gray-500 dark:text-gray-400">|</span>
            <p className="text-sm text-gray-500 dark:text-gray-400">{courseName}</p>
          </div>
        </div>

        {/* محتوى البطاقة */}
        <div className="flex h-[calc(100%-4rem)] overflow-hidden">
          {/* قائمة المتدربين (تظهر في الكمبيوتر أو في الموبايل عند عرض القائمة) */}
          {(!isMobile || activeView === 'list') && (
            <div className="w-full md:w-1/3 border-l border-gray-200 dark:border-gray-700 overflow-y-auto scrollbar-hide h-full">
              {trainees.length === 0 ? (
                <div className="p-6 text-center text-gray-500 dark:text-gray-400">
                  لا يوجد متدربين لديهم أسئلة في هذه الدورة
                </div>
              ) : (
                trainees.map(trainee => (
                  <div
                    key={trainee.id}
                    onClick={() => handleTraineeSelect(trainee)}
                    className={`p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-700 ${
                      selectedTrainee?.id === trainee.id ? 'bg-gray-50 dark:bg-gray-700' : ''
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="ml-3 relative">
                        <div className="w-10 h-10 rounded-full flex items-center justify-center overflow-hidden">
                          {trainee.avatar ? (
                            <img src={getAvatarSrc(trainee.avatar)} alt={trainee.name} className="w-full h-full object-cover" />
                          ) : (
                            <div className="w-full h-full bg-blue-100 dark:bg-blue-800 flex items-center justify-center">
                              <span className="text-blue-600 dark:text-blue-200 font-medium">{trainee.name.slice(0,2)}</span>
                            </div>
                          )}
                        </div>
                        <span 
                          className={`absolute -bottom-1 -left-1 h-3 w-3 rounded-full ${
                            trainee.status === 'online' ? 'bg-green-500' : 'bg-gray-500'
                          } border-2 border-white dark:border-gray-800`}
                        ></span>
                      </div>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-gray-800 dark:text-gray-200">{trainee.name}</p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          {trainee.last_message}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          {trainee.last_active_at && new Date(trainee.last_active_at).toLocaleString('ar-EG', { dateStyle: 'short', timeStyle: 'short', numberingSystem: 'latn' })}
                        </p>
                      </div>
                      <div className="flex items-center">
                        {trainee.unread_count > 0 && (
                          <span className="inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-blue-500 rounded-full mr-2">
                            {trainee.unread_count}
                          </span>
                        )}
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            setTraineeToDelete(trainee);
                            setShowDeleteModal(true);
                          }}
                          className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors"
                          title="حذف المحادثة"
                        >
                          <HiOutlineTrash className="h-5 w-5" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
          
          {/* منطقة المحادثة (تظهر في الكمبيوتر أو في الموبايل عند عرض المحادثة) */}
          {(!isMobile || activeView === 'chat') && (
            <div className="flex-1 flex flex-col">
              {/* زر الرجوع للقائمة في الموبايل */}
              {isMobile && (
                <button 
                  className="flex items-center justify-center p-2 text-blue-600 font-medium w-full"
                  onClick={() => setActiveView('list')}
                >
                  <HiOutlineArrowLeft className="mr-2" />
                  رجوع للقائمة
                </button>
              )}
              
              {/* منطقة المحادثة */}
              {selectedTrainee ? (
                <>
                  {isLoadingMessages ? (
                    <div className="flex-1 flex items-center justify-center">
                      <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  ) : (
                    <>
                      {/* حالة المتدرب */}
                      <div className="text-center py-2 border-b border-gray-200 dark:border-gray-700 -mt-2">
                        <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs ${traineeStatus === 'online' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'}`}>
                          <span className={`h-2 w-2 rounded-full ${traineeStatus === 'online' ? 'bg-green-500' : 'bg-gray-500'} ml-2`}></span>
                          {traineeStatus === 'online' ? 'متصل الآن' : 'غير متصل حالياً'}
                        </div>
                      </div>
                      
                      {/* منطقة الرسائل */}
                      <div className="flex-1 overflow-y-auto scrollbar-hide p-4" style={{ backgroundColor: 'transparent' }}>
                      {messages.length === 0 ? (
                        <div className="flex flex-col items-center justify-center h-full text-gray-500 dark:text-gray-400">
                          <HiOutlineChat className="h-12 w-12 mb-3" />
                          <p>لا توجد رسائل بعد. ابدأ محادثة جديدة مع المتدرب.</p>
                        </div>
                      ) : (
                        <>
                          {messages.map((message) => {
                            const isTrainee = message.sender_type === 'trainee';

                            // اتجاه الرسالة في RTL
                            const alignment = isTrainee ? 'justify-end' : 'justify-start';

                            // لون الفقاعة حسب المرسل
                            const bubbleClasses = isTrainee
                              ? 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white rounded-tr-lg rounded-tl-lg rounded-br-lg'
                              : 'bg-blue-600 text-white rounded-tr-lg rounded-tl-lg rounded-br-lg';

                            const textAlign = isTrainee ? 'text-left' : 'text-right';

                            // تحديد ما إذا كانت الرسالة صوتية
                            const isAudioMessage = message.content_type === 'audio';
                            
                            // التحقق من نوع الرسالة الصوتية
                            
                            return (
                              <div key={message.id} className={`mb-3 w-full flex ${alignment}`}>
                                <div className={`inline-block px-3 py-2 rounded-lg ${isAudioMessage ? (isTrainee ? 'bg-gray-200 dark:bg-gray-800/50 border border-gray-300 dark:border-gray-700' : 'bg-blue-200 dark:bg-blue-900/30 border border-blue-300 dark:border-blue-800') : bubbleClasses}`} style={isAudioMessage ? {marginRight: isTrainee ? 'auto' : '0', marginLeft: isTrainee ? '0' : 'auto'} : {}}>
                                  {isAudioMessage ? (
                                    // عرض مشغل الصوت إذا كانت رسالة صوتية
                                    <div className="my-1">
                                      <div className="text-xs mb-1 font-medium text-center">
                                        {isTrainee ? 'رسالة صوتية' : 'رسالة صوتية'}
                                      </div>
                                      <div style={{ 
                                        padding: '2px', 
                                        display: 'inline-block'
                                      }}>
                                        <audio 
                                          controls 
                                          controlsList="nodownload" 
                                          src={message.file_path ? `${axiosInstance.defaults.baseURL}/storage/${message.file_path}` : ''} 
                                          className="max-w-[250px]"
                                          preload="metadata"
                                          onContextMenu={(e) => e.preventDefault()} 
                                          onError={(e) => {
                                            // معالجة خطأ الصوت بسلاسة
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    // عرض النص إذا كانت رسالة نصية
                                    <p className={`text-sm ${textAlign}`}>{message.message}</p>
                                  )}
                                  <div className={`text-xs mt-1 opacity-75 ${textAlign}`}>
                                    {(() => {
                                      const date = new Date(message.created_at);
                                      const hours = date.getHours();
                                      const minutes = date.getMinutes();
                                      const ampm = hours >= 12 ? 'م' : 'ص';
                                      const hour12 = hours % 12 || 12;
                                      return `${hour12}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
                                    })()}
                                    {message.is_read && isTrainee && <span className="mr-2">✓</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          <div ref={messagesEndRef} />
                        </>
                      )}
                    </div>
                    </>
                  )}
                </>
              ) : (
                <div className="flex-1 flex items-center justify-center text-gray-500 dark:text-gray-400">
                  <p>اختر متدرباً من القائمة لبدء المحادثة</p>
                </div>
              )}

              {/* منطقة إدخال الرسالة */}
              {selectedTrainee && !isLoadingMessages && (
                <div className="p-4 border-t border-gray-200 dark:border-gray-700">
                  <div className="flex items-center gap-2">
                    <button 
                      onClick={isRecording ? stopRecording : startRecording}
                      disabled={!conversationId}
                      className={`p-2 rounded-full ${
                        !conversationId
                          ? 'text-gray-300 cursor-not-allowed'
                          : isRecording 
                            ? 'bg-red-500 text-white animate-pulse'
                            : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
                      }`}
                      title={!conversationId ? 'يجب تحميل المحادثة أولاً' : 'تسجيل رسالة صوتية'}
                    >
                      {isRecording ? <HiOutlineStop className="h-6 w-6" /> : <HiOutlineMicrophone className="h-6 w-6" />}
                    </button>
                    <input
                      type="text"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && e.shiftKey === false && handleSendMessage()}
                      placeholder="اكتب رسالتك هنا..."
                      disabled={!conversationId || isRecording}
                      className="flex-1 input-base"
                    />
                    <button 
                      onClick={handleSendMessage}
                      disabled={!conversationId || (!newMessage.trim() && !isRecording)}
                      className={`p-2 ${
                        !conversationId || (!newMessage.trim() && !isRecording)
                          ? 'text-gray-300 cursor-not-allowed'
                          : 'text-blue-600 hover:text-blue-700 dark:text-blue-500 dark:hover:text-blue-400'
                      }`}
                      title="إرسال الرسالة"
                    >
                      <HiOutlinePaperAirplane className="h-6 w-6" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      
      {/* مودال تأكيد الحذف */}
      {showDeleteModal && traineeToDelete && (
        <AlertConfirmModal
          isOpen={showDeleteModal}
          onClose={() => {
            setShowDeleteModal(false);
            setTraineeToDelete(null);
          }}
          onConfirm={() => {
            // دالة حذف المحادثة
            const deleteConversation = async () => {
              try {
                const conversationIdToDelete = traineeToDelete.conversation_id;
                // جاري حذف المحادثة مع المتدرب
                
                // استدعاء API لحذف المحادثة
                const response = await axiosInstance.delete(`/api/chat/conversations/${conversationIdToDelete}`);
                
                if (response.data && response.data.status === 'success') {
                  // تحديث قائمة المتدربين بعد الحذف
                  setTrainees(prevTrainees => prevTrainees.filter(t => t.id !== traineeToDelete.id));
                  
                  // إذا كان المتدرب المحذوف هو المحدد حالياً، نقوم بإعادة تعيين المتدرب المحدد
                  if (selectedTrainee && selectedTrainee.id === traineeToDelete.id) {
                    setSelectedTrainee(null);
                    setMessages([]);
                    setConversationId(null);
                  }
                  
                  toastService.success('تم حذف المحادثة بنجاح');
                } else {
                  toastService.error('حدث خطأ أثناء حذف المحادثة');
                }
              } catch (error) {
                // خطأ في حذف المحادثة
                toastService.error('حدث خطأ أثناء حذف المحادثة');
              } finally {
                setShowDeleteModal(false);
                setTraineeToDelete(null);
              }
            };
            
            // تنفيذ دالة الحذف
            deleteConversation();
          }}
          icon={HiOutlineTrash}
          iconColorClass="text-red-500"
          title="حذف المحادثة"
          message={`هل أنت متأكد من حذف المحادثة مع ${traineeToDelete.name}؟`}
          details="سيتم حذف جميع الرسائل المرتبطة بهذه المحادثة بشكل نهائي."
          note="لا يمكن التراجع عن هذه العملية."
          confirmText="حذف"
          cancelText="إلغاء"
        />
      )}
    </div>
  );
};

export default ChatCard;
